import { render, staticRenderFns } from "./filedetail-update.vue?vue&type=template&id=a4e16704&scoped=true&"
import script from "./filedetail-update.vue?vue&type=script&lang=js&"
export * from "./filedetail-update.vue?vue&type=script&lang=js&"
import style0 from "./filedetail-update.vue?vue&type=style&index=0&id=a4e16704&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e16704",
  null
  
)

export default component.exports